import { useEffect, useState } from "react"
import ReactDOM from "react-dom"

const Portal = ({ children }) => {
  const [modalContainer] = useState(document.createElement("div"))
  useEffect(() => {
    let modalRoot = document.getElementById("portalRoot")

    if (!modalRoot) {
      const tempEl = document.createElement("div")
      tempEl.id = "portalRoot"
      document.body.append(tempEl)
      modalRoot = tempEl
    }
    // Append modal container to root
    modalRoot.appendChild(modalContainer)
    return function cleanup() {
      // On cleanup remove the modal container
      modalRoot.removeChild(modalContainer)
    }
  }, [modalContainer])

  return ReactDOM.createPortal(children, modalContainer)
}

export default Portal
